import { render } from "./PlayoutDashboard.vue?vue&type=template&id=bda56b4e"
import script from "./PlayoutDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TVPlayoutDash/PlayoutDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bda56b4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bda56b4e', __exports__)) {
    api.reload('bda56b4e', __exports__)
  }
  
  module.hot.accept("./PlayoutDashboard.vue?vue&type=template&id=bda56b4e", () => {
    api.rerender('bda56b4e', render)
  })

}


export default __exports__